import React from "react";
import { LockIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
  tone?: "light" | "dark";
};
export function SectionCta({
  label,
  tone = "light"
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl" data-id="element-65" data-mp="3id6xf85hr2aw">
      <CtaButton label={label} data-id="element-66" data-mp="3nc0ax0ks2tb2" />
      <p className={`mt-4 flex items-center justify-center gap-1.5 text-center text-sm font-medium ${tone === "dark" ? "text-white/75" : "text-muted"}`} data-id="element-67" data-mp="3nb8jm1y7rhql">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="3df5fiqjsx910" />
        $27 USD · One-Time Payment · Instant Access
      </p>
    </div>;
}